import { mockTxRegistrySummary, mockTxRegistryItems } from '@/__mocks__';

const txRegistryApi = {
  requestList() {
    return new Promise((resolve) => {
      const txs = 10;
      setTimeout(() => {
        const items = {
          data: {
            txs: mockTxRegistryItems(txs),
            paging: {
              next_cursor: 'MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              next_link:
                'https://localhost/items?cursor=MjAyMS0wOC0wMVQxNToyNTo0OS4zODg3MjNa',
              total_count: txs,
            },
          },
        };
        resolve(items);
      }, 100);
    });
  },
  requestSummary() {
    return new Promise((resolve) => {
      setTimeout(() => {
        const summary = { data: mockTxRegistrySummary() };
        resolve(summary);
      }, 100);
    });
  },
};

export default txRegistryApi;
